import { render, staticRenderFns } from "./SessionInfo.vue?vue&type=template&id=72245244&scoped=true&"
import script from "./SessionInfo.vue?vue&type=script&lang=ts&"
export * from "./SessionInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72245244",
  null
  
)

export default component.exports